import React, { useEffect, useState } from "react";
import { Avatar, Box, Button, CircularProgress, Container, createTheme, CssBaseline, Dialog, DialogContent, DialogTitle, Divider, FormControl, Grid, InputLabel, MenuItem, Paper, Select, TextField, ThemeProvider, Typography } from "@mui/material";
import { renderToString } from 'react-dom/server';
import { SelectCustom } from "../modules/ui/SelectCustom";
import moment from "moment";
import SendIcon from "@mui/icons-material/Send";
import { SelectCountryAndRegion } from "../modules/ui/SelectCountryAndRegion";
import Swal from "sweetalert2";
import { uploadFile } from "../../services/uploadFile";
import validator from 'validator';
import { sendEmail } from "../../services/sendEmail";
import { generateRef } from "../../helpers/generateRef";
import { SelectCustomWithOther } from "../modules/ui/SelectCustomWithOther";

import { instituciones } from '../../helpers/catalogs/anuies';
import { getAllFromRegistroGeneral, postOne } from "../../database/dbRegistroGeneral";
import { reportError } from "../../services/reportError";
import { getAllFromEduconCursosActivos } from "../../database/dbEduconCursosActivos";
import { setEmailBodyRegistroGeneral } from "../../helpers/emails/setEmailBodyRegistroGeneral";
import { getAllEventosConRegistro } from "../../database/dbEventosConRegistro";

import QRCode from 'qrcode';
import { getBankingInfo } from "../../database/dbBankingInfo";



/* 
OK - Al seleccionar el educon, validar si el cupo maximo ya ha sido alcanzado y notificar al usuario.

OK - Si aun hay cupo general, verificar si el educon es mixto, si esto es afirmativo:
OK - al participante le permitiremos escoger modalidad: presencial, virtual o mixto.
OK - Al seleccionar una modalidad, validar el cupo maximo de esa modalidad y notificar al usuario.
*/


export const Educon = () => {

    const queryParameters = new URLSearchParams(window.location.search);
    const mode = queryParameters.get("mode");

    // state para la info bancaria (en caso de ser necesaria)
    const [bankingInfo, setBankingInfo] = useState(null);
  
    // state para las anuies
    const institucionesANUIES = instituciones.sort((a,b) => (a.nombre > b.nombre) ? 1 : ((b.nombre > a.nombre) ? -1 : 0));

    // state para cuando esta cargando info
    const [isLoading, setIsLoading] = useState(true);

    // state para los educons a enlistar como opciones para el usuario
    const [educons, setEducons] = useState([]);

    // const [currentEduconData, setCurrentEduconData] = useState([]);
    const [isMixed, setIsMixed] = useState(false);

    // state para los valores del formulario
    const [formValues, setFormValues] = useState({
        //* Los siguientes inputs los comparten todos los formularios (registros)
        partApellidoPaterno: "",
        partApellidoMaterno: "",
        partNombres: "",
        partCorreo: "",
        partCorreoConfirma: "",
        partPais: "",
        partEstado: "",
        tipoRegistro: "",
        tipoRegistroDocURL: "",

        registroClaveProyecto: "",
        registroFecha: moment().format('YYYY-MM-DDTHH:mm:ss'),
        registroReferencia: "",

        //* Estos son los elementos necesarios para este registro en particular
        partEdad: "",
        partSexo: "",
        partTelefono: "",
        partCelular: "",
        partLenguaIndigena: "",
        partDiscapacidad: "",
        partOcupacion: "",
        partGradoAcademico: "",
        partInstProcedencia: "",

        educonId: "",
        educonSolicitudId: "",
        educonInicio: "",
        educonTitulo: "",
        educonResponsableId: "",
        educonCorreo: "",
        educonModalidad: "",
    });
    const {
        partApellidoPaterno,
        partApellidoMaterno,
        partNombres,
        partCorreo,
        partCorreoConfirma,
        partPais,
        partEstado,
        tipoRegistro,

        registroClaveProyecto,
        registroFecha,
        registroReferencia,

        //*,
        partEdad,
        partSexo,
        partTelefono,
        partCelular,
        partLenguaIndigena,
        partDiscapacidad,
        partOcupacion,
        partGradoAcademico,
        partInstProcedencia,

        educonId,
        educonSolicitudId,
        educonInicio,
        educonTitulo,
        educonResponsableId,
        educonCorreo,
        educonModalidad,
    } = formValues;

    // state para el fileupload
    const [file, setFile] = useState({
        file: '',
    });
    const setFileState = (e) => {    
        setFile({ file: e.target.files[0] });    
    };

    // state para el codigo QR
    const [src, setSrc] = useState({ qrdata:"" });
    
    // Para el selector de tipoRegistro
    const [addCredential, setAddCredential] = useState(false);

    const [isWaiting, setIsWaiting] = useState(false);
    // Para mostrar un dialogo mientras se envia la info (waiting dialog)
    const [sendingForm, setSendingForm] = useState(false);
    const handleCloseWaitingDialog = (_, reason) => {
        if (reason !== 'backdropClick') { }
    };

    const [educonSelected, setEduconSelected] = useState(null);
    const [recordsEduconSelected, setRecordsEduconSelected] = useState([]);

    // Check whether any of the form fields are unedited
    const isSendButtonDisabled = () => (
        false
        ||
        formValues.partApellidoPaterno.length === 0 ||
        formValues.partNombres.length === 0 ||
        formValues.partCorreo.length === 0 ||
        formValues.partCorreoConfirma.length === 0 ||
        formValues.partPais.length === 0 ||
        formValues.partEstado.length === 0 ||
        formValues.tipoRegistro.length === 0 ||
        // Lo nuevo
        formValues.partEdad.length === 0 ||
        formValues.partSexo.length === 0 ||
        formValues.partTelefono.length === 0 ||
        formValues.partCelular.length === 0 ||
        formValues.partLenguaIndigena.length === 0 ||
        formValues.partDiscapacidad.length === 0 ||
        formValues.partOcupacion.length === 0 ||
        formValues.partGradoAcademico.length === 0 ||
        formValues.partInstProcedencia.length === 0 ||

        formValues.educonTitulo.length === 0
    );

    // Cada que cambia el valor en cualquier control de formulario
    const handleInputChange = ({ target }) => {
        // console.log(target.name, target.value);
        setFormValues({
            ...formValues,
            [target.name]: target.value,
        });
    };

    // Cada que cambia el pais y estado
    const handleCountryAndRegionChange = ({ country, region }) => {
        // console.log(country, region);
        setFormValues({
            ...formValues,
            partPais: country,
            partEstado: region,
        })
    }

    // Para el selector de tipo de registro
    const handleTipoRegistro = ({ target }) => {
        const { name, value } = target;
        switch (value) {
            case 'Participante externo':
                setAddCredential(false);
                break;
                
            default:
                    setAddCredential(true);
                break;
        }

        setFormValues({ ...formValues, [name]: value, });
    }

    /**
    //* Al momento de seleccionar el educon debemos:
    - Con -cupo- revisar cuantos estan inscritos y si superan el maximo de capacidad, mostrarle un alert al usuario avisando que ya no hay cupo.
        - OK
    
    Si todavia hay cupo: y -modalidad- === 'Mixto':
    - Mostrar la opcion de como desea presentarse al curso ["Presencial", "A distancia"], y al seleccionar cada una,
        - OK 
    */
    const handleCursoChange = async({ target }) => {
        const { value } = target;
        console.log({value});

        setIsWaiting(true);
            
        // obtenemos el curso seleccionado
        const cursoSeleccionado = educons.find(item => item.folio === value);
        console.log({cursoSeleccionado});
        setEduconSelected(cursoSeleccionado);
        
        const { fechaInicio, curso, responsableCurso, solicitudID, correoEventos, modalidad, cve_Proyec, cupo, costo } = cursoSeleccionado;

        //* Obtenemos los registros en RegistroGeneral
        const { exito, mensaje, data: allFromRegistroGeneral } = await getAllFromRegistroGeneral();
        allFromRegistroGeneral.forEach(afrg => {
            afrg.infoAdicionalObj = JSON.parse(afrg.infoAdicional);
            afrg.solicitudID = afrg.infoAdicionalObj.educonSolicitudId;
        })
        console.log({ allFromRegistroGeneral });

        //* Filtramos los registros de RegistroGeneral para saber cuantos inscritos hay
        const dataFromDB = allFromRegistroGeneral.filter(afrg => afrg.solicitudID === cursoSeleccionado.solicitudID);
        console.log({dataFromDB});
        setRecordsEduconSelected(dataFromDB);
        
        setIsWaiting(false);

        //* Ya no hay cupo, notificar y salir
        if ( cupo <= dataFromDB.length ) {
            Swal.fire({
                allowEscapeKey: false,
                allowOutsideClick: false,
                confirmButtonText: 'Ver más cursos de educación continua',
                icon: 'info',
                text: `"${ curso }" ya no cuenta con espacios disponibles, por favor consulte el siguiente enlace:`,
                title: `Capacidad máxima alcanzada.`,
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.replace('https://www.cibnor.gob.mx/posgrados/educacion-continua');
                }
            }); 
            return;
        }

        // Seteamos el state de modalidad para lo subsecuente
        (modalidad.toLowerCase() === 'mixto') ? setIsMixed(true) : setIsMixed(false);

        // Inicializamos la referencia dependiendo la -cve_Proyec-
        const registroRef = (cve_Proyec !== '0') 
            ? generateRef({ prefix:cve_Proyec }) 
            : generateRef({ prefix:`24274` });

        setFormValues({
            ...formValues,
            educonId: value,
            educonSolicitudId: solicitudID,
            educonInicio: fechaInicio,
            educonTitulo: curso,
            educonResponsableId: responsableCurso,
            educonCorreo: correoEventos,
            educonModalidad: modalidad,
            registroClaveProyecto: cve_Proyec,
            registroReferencia: registroRef,
            registroConfirma: costo > 0 ? 1 : 0,
        });

        // Generamos el qr y su string a almacenar
        const qrString = `${process.env.REACT_APP_HOMEPAGE}/visualizar-registro/${ registroRef }`;
        QRCode.toDataURL( qrString )
        .then( (data) => { setSrc( { qrdata:data } ); })
    };


    // Al cambiar la modalidad, el control solo aparece si la actividad es modalidad: "Mixto"
    const handleModalidadChange = async({ target }) => {

        // console.log({educonSelected});
        // const value = formValues.educonId;
        // const educonSelected = educons.filter(item => item.folio === value)[0];
        console.log({educonSelected});
        //* Revisar en -observacionEventos- el prefijo 'Mixto:10/10', presencial/distancia )
        const { observacionEventos } = educonSelected;
        
        //! Esto de 'Mixto:10/10' no lo esta capturando el operador
        // Revisar en -observacionEventos- el prefijo del texto a convenir ( 'Mixto:10/10', presencial/distancia ), si este prefijo existe, validar cuantos estan inscritos con esa modalidad y si ya no hay cupo, avisarle al usuario avisando que ya no hay espacios.
        
        //* Si este prefijo existe, validar cuantos estan inscritos con esa modalidad
        const subStrObs = observacionEventos.substring(0, 5).toLowerCase();
        if (subStrObs === 'mixto') {
            // Extraer las cantidades de presencial y virtual
            const capacidades = observacionEventos.substring(6, 11).split('/');
            console.log({capacidades});
            // TODO: Verificar que de lo seleccionado todavia hay espacios y en caso contrario, avisar al usuario para que cambie la opcion
            // En el state 'recordsEduconSelected' estan los registros correspondientes a la actividad seleccionada
        }

        setFormValues({ ...formValues, [target.name]: target.value, });
    }


    // Procesamiento de la info
    const isDataProcessed = async() => {

        // Si se requirió, se sube archivo
        if (addCredential) {
            // - subir archivo en PDF
            const resultUpload = await uploadFile({ file, fileName: `credTR_${ registroReferencia }.pdf` });
            console.log({resultUpload});

            // Error al subir el archivo, notificar y salir
            if (resultUpload.exito === 0) {
                reportError({ emailTo: 'jcollins@cibnor.mx', values: resultUpload, task: 'Al subir comprobante -tipoRegistro-' });
                return false;
            }

            formValues.tipoRegistroDocURL = `https://eventos.cibnor.mx/registro/apiServiciosSIARF${ resultUpload.data }`;
        }
        
        // Creamos el objeto
        const infoAdicionalObj = {
            partEdad,
            partSexo,
            partTelefono,
            partCelular,
            partLenguaIndigena,
            partDiscapacidad,
            partOcupacion,
            partGradoAcademico,
            partInstProcedencia,

            educonId,
            educonSolicitudId,
            educonInicio,
            educonTitulo,
            educonResponsableId,
            educonCorreo,
            educonModalidad,

            //? Eliminamos el guardar el qrdata (ocupa mucho espacio y es dificil de leer), sí se genera y se usa para el envio de coreo
            // registroDataQR: src.qrdata,
            
            //? En su lugar, guardamos la data que debe contener el codigo QR (de esta manera se puede generar en cualquier lado)
            registroQR: `https://eventos.cibnor.mx/registro/en-linea/visualizar-registro/${ registroReferencia }`,

            // 0 = no paga, 1 = paga y confirma su registro subiendo su comprobante
            registroConfirma: formValues.registroConfirma ?? 0, 
            registroConfirmaFecha: "",
        };


        //* Construir el objeto a enviar en el POST
        const valuesObj = {
            partApellidoPaterno: partApellidoPaterno,
            partApellidoMaterno: partApellidoMaterno,
            partNombres: partNombres,
            partCorreo: partCorreo,
            partPais: partPais,
            partEstado: partEstado,
            tipoRegistro: tipoRegistro,
            tipoRegistroDocURL: formValues.tipoRegistroDocURL,
            registroClaveProyecto: registroClaveProyecto,
            registroFecha: registroFecha,
            registroReferencia: registroReferencia,
            infoAdicional: JSON.stringify(infoAdicionalObj)
        }
        console.log("Objeto a enviar en el POST");
        console.log({valuesObj});

        //* POST en dbRegistroGeneral
        const resultPost = await postOne({ values:valuesObj });
        console.log(resultPost);



        // Error al guardar en la bdd, notificar y salir
        if (resultPost.exito === 0) {
            console.log({ resultPost });
            reportError({ emailTo: 'jcollins@cibnor.mx', values: resultPost, task: 'Al guardar en -RegistroGeneral-' });
            return false;
        }


        // //* Obtenemos los generales desde EventosConRegistro para saber si se cobra o no, entre otros detalles
        const { data: eventosConRegistro } = await getAllEventosConRegistro();
        console.log({eventosConRegistro});


        // Construir 'eventData'
        const eventData = { 
            correoEvento: educonSelected.correoEventos,
            urlLogo: 'https://eventos.cibnor.mx/intranet/img/logo_cib.png', 
            tituloEvento: educonTitulo, 
            urlConfirmarRegistro: `https://eventos.cibnor.mx/registro/en-linea/confirmar-registro/${ registroReferencia }`
        }

        console.log("--- Objeto a enviar para crear el body del correo");
        console.log({eventData});
        
        // Armar el body con los datos del formulario y los datos del evento al que se esta registrando
        const msgbody = renderToString( setEmailBodyRegistroGeneral({ values: valuesObj, eventData, qrData: src.qrdata, bankingInfo }) );

        //* Si estas en produccion, agregale el correo del titular del evento
        const envToCC = process.env.REACT_APP_TOCC_EDUCON;
        const toccAddresses = (envToCC !== '') ? envToCC + `, ${ eventData.correoEvento }` : envToCC;
        console.log({toccAddresses});

        const emailResult = await sendEmail({
            "toemail": partCorreo,
            "subject": `Registro en línea [${ eventData.tituloEvento }]`,
            "message": msgbody,
            "replyto": eventData.correoEvento,
            "tocc": toccAddresses,
        });
        console.log({emailResult});

        // Error al recuperar los generales del evento desde EventosConRegistro
        if (emailResult.exito === 0) {
            console.log({ emailResult });
            reportError({ emailTo: 'jcollins@cibnor.mx', values: emailResult, task: 'Al enviar el correo de acuse de registro' });
            return false;
        }

        return true;
    };


    // Del sweetalert, cuando el usuario decide "continuar"
    const continueConfirmed = async() => {
        // Mostrar waiting dialog
        setSendingForm(true);

        // Se procesa la info
        const resultDataProcessed = await isDataProcessed(); 

        // Ocultar waiting dialog
        setSendingForm(false);

        // Notificar el exito del guardado, en caso contrario notificar al usuario y reportar incidente
        if (resultDataProcessed) {
            Swal.fire({
                allowEscapeKey: false,
                allowOutsideClick: false,
                confirmButtonText: 'Ver más cursos de educación continua',
                icon: 'success',
                text: 'Consulte su correo electrónico para más información.',
                title: "Sus datos han sido recibidos exitosamente",
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.replace('https://www.cibnor.gob.mx/posgrados/educacion-continua');
                }
            }); 
        } else {
            Swal.fire({
                allowEscapeKey: false,
                allowOutsideClick: false,
                title: "Sucedío un error en el servidor.",
                text: 'Disculpe el inconveniente, por favor reintente más tarde.',
                icon: 'error',
                showConfirmButton: false,
                footer: 'El area correspondiente ya ha sido notificada.'
            }); 

            sendEmail({
                "toemail": "jcollins@cibnor.mx",
                "subject": "[Educon] Error",
                "message": formValues,
            });
        }
    }


    // Validar el formumario
    const isFormValid = () => {

        // Campos de correo validos
        if ( !validator.isEmail(partCorreo) || !validator.isEmail(partCorreoConfirma) ) {
            Swal.fire("Correo electrónico incorrecto.", "Confirmar el correo electrónico ingresado.", "error");
            return false;
        }

        // Campos de correo  iguales
        if ( partCorreo !== partCorreoConfirma ) {
            Swal.fire("Confirmar correo electrónico.", "La confirmación de correo electrónico no coincide.", "error");
            return false;
        }

        if (addCredential) {
            // No ha indicado ningun archivo
            if ( file.file === '' ) {
                Swal.fire("Agregar documento.", `Por favor selecciona un archivo como credencial.`, "error");
                return false;
            }
            // Indico archivo pero no es un PDF
            const fullName = file.file.name;
            const fileExt = fullName.substring( fullName.indexOf('.') + 1 ).toUpperCase();
            if ( file.file !== '' && fileExt !== 'PDF' ) {
                Swal.fire("Documento incorrecto.", `La credencial debe ser un archivo PDF.`, "error");
                return false;
            }
        }

        if (isMixed) {
            if ( [ educonModalidad ].includes("") ) {
                Swal.fire("Datos incompletos.", "Es necesario seleccionar una modalidad.", "error");
                return false;
            }
        }

        return true;
    }
    

    const handleSubmit = async (event) => {
        event.preventDefault();

        console.log({formValues});

        //* Validar datos
        if ( !isFormValid() ) { return false; }

        // Mostrar confirm dialog/waiting dialog
        Swal.fire({
            title: '¿Desea continuar?',
            text: "Por favor, confirme la información ingresada.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Regresar',
        }).then((result) => {
            if (result.isConfirmed) {
                //* El usuario confirma procesar la data
                continueConfirmed();
            }
        })
    }


    useEffect(() => {
        
        const setInitialValues = async() => {
            document.title = "[EduCon] CIBNOR";

            const { exito, mensaje, data } = await getAllFromEduconCursosActivos();
            console.log( exito, mensaje, data );

            // Error al cargar los educon, notificar y salir
            if (exito === 0) {
                setIsLoading(false);
                reportError({ emailTo: 'jcollins@cibnor.mx', values: mensaje, task: 'Al cargar los cursos EDUCON' });
                Swal.fire({
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    html: `El incidente ya ha sido reportado. Dudas: <strong>educon@cibnor.mx</strong>`,
                    icon: 'error',
                    showConfirmButton: false,
                    title: `¡Ups! ocurrió un error. Por favor inténtelo mas tarde.`,
                });
                return
            }

            const result = await getBankingInfo();
            console.log({result});
            if (result) {
                setBankingInfo(result.datos);
            }

            // Filtramos solo a los que estan ofertados actualmente
            let ofertados = data.filter( item => item.ofertado !== '0');
            //! Para pruebas (in url add: ?mode=testing)
            if (mode === 'testing') {
                // ofertados = []
                ofertados = [
                    {
                        folio: 1,
                        fechaInicio: '2023-02-13T00:00:00Z',
                        fechaFinal: '2023-03-30T00:00:00Z',
                        duracionHoras: 20,
                        cupo: 40,
                        costo: 1000.0,
                        curso:'Introducción a R',
                        tipoCurso:'',
                        modalidad:'Mixto',
                        responsableCurso:'',
                        cve_Proyec:'20487',
                        email:'jorge.collins@gmail.com',
                        ofertado:'1',
                        solicitudID: 143,
                        tipoMoneda:'Pesos Mexicanos',
                        correoEventos:'jorge.collins@gmail.com',
                        observacionEventos:'Datos del Curso:\r\n\r\n\r\n    Curso: Introducción a R\r\n    Responsable: Dr. Raúl Octavio Martínez Rincón\r\n    No. Folio: 0001\r\n    No. Solicitud: 143\r\n    Fecha de impartición: 13 al 17 de febrero de 2023\r\n    Clave presupuestal: 20487\r\n    No. Oficio Posgrado: DEPYFRH-O022/2023',
                        fechaSolicitudID:'',
                    },
                    {
                        folio: 2,
                        fechaInicio: '2023-02-13T00:00:00Z',
                        fechaFinal: '2023-03-30T00:00:00Z',
                        duracionHoras: 20,
                        cupo: 12,
                        costo: 1000.0,
                        curso:'Pruebas Developer',
                        tipoCurso:'',
                        modalidad:'Presencial',
                        responsableCurso:'804',
                        cve_Proyec:'20483',
                        email:'jorge.collins@gmail.com',
                        ofertado:'1',
                        solicitudID: 143,
                        tipoMoneda:'Pesos Mexicanos',
                        correoEventos:'jorge.collins@gmail.com',
                        observacionEventos:'Datos del Curso:\r\n\r\n\r\n    Curso: Introducción a R\r\n    Responsable: Dr. Raúl Octavio Martínez Rincón\r\n    No. Folio: 0001\r\n    No. Solicitud: 143\r\n    Fecha de impartición: 13 al 17 de febrero de 2023\r\n    Clave presupuestal: 20487\r\n    No. Oficio Posgrado: DEPYFRH-O022/2023',
                        fechaSolicitudID:'',
                    },
                ]
            }
            //!
            console.log({ofertados});
            
            // Seteamos su state
            setEducons(ofertados);

            // Ya termino de cargar la info
            setIsLoading(false);

            // Si no hay educons ofertados, notificar al usuario
            if (ofertados.length <= 0) {
                Swal.fire({
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    html: `Dudas o consultas favor de comunicarse a: <strong>educon@cibnor.mx</strong>`,
                    icon: 'info',
                    showConfirmButton: false,
                    title: `Actualmente no hay cursos disponibles para registrarse.`,
                });
                return
            }
            
        }

        setInitialValues();
    }, [ mode ])
    

    return (
        <ThemeProvider theme={createTheme()}>
            <Container component="main" maxWidth="sm" >
            <CssBaseline />
            <Box sx={{ mt: 4, mb: 8, display: "flex", flexDirection: "column", alignItems: "center" }} >
                <Avatar
                    sx={{ width: 240, height: 136 }}
                    src="https://eventos.cibnor.mx/registro/en-linea/_logos/posgradoCib.png"
                    variant="square" 
                />
                <Typography variant="h6" sx={{ my: 3 }}>Registro inicial a cursos de Educación Continua</Typography>



                {/* Inicio del formulario */}
                <Box
                    component="form"
                    noValidate
                    onSubmit={handleSubmit}
                    sx={{ mt: 2 }}
                    autoComplete="off"
                    maxWidth="sm"
                >
                    {/* Participante */}
                    <Paper elevation={2}>
                        <Grid container spacing={2} sx={{ flexGrow: 1, px: 3 }} >

                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    id="partApellidoPaterno"
                                    label={`Apellido paterno`}
                                    name="partApellidoPaterno"
                                    required
                                    size="small"
                                    value={partApellidoPaterno}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    id="partApellidoMaterno"
                                    label={`Apellido materno`}
                                    name="partApellidoMaterno"
                                    size="small"
                                    value={partApellidoMaterno}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    id="partNombres"
                                    label={`Nombre(s)`}
                                    name="partNombres"
                                    required
                                    size="small"
                                    value={partNombres}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    id="partCorreo"
                                    label="Correo electrónico"
                                    name="partCorreo"
                                    required
                                    size="small"
                                    value={partCorreo}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    id="partCorreoConfirma"
                                    label="Confirmar correo electrónico"
                                    name="partCorreoConfirma"
                                    required
                                    size="small"
                                    value={partCorreoConfirma}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            {/* Pais y estado */}
                            <Grid item xs={12}>
                                <SelectCountryAndRegion 
                                    parentCallback={handleCountryAndRegionChange} 
                                    paddingH={0}
                                    paddingV={0}
                                    variant="outlined" 
                                />
                            </Grid>
                            {/* Tipo de registro [ trab, est, ext ] */}
                            <Grid item xs={12} >
                                <SelectCustom
                                    parentCallback={handleTipoRegistro}
                                    name={"tipoRegistro"}
                                    label={"Tipo de registro"}
                                    options={[
                                        {value:'Trabajador CIBNOR', label:'Trabajador CIBNOR'},
                                        {value:'Estudiante CIBNOR', label:'Estudiante CIBNOR'},
                                        {value:'Estudiante externo', label:'Estudiante externo'},
                                        {value:'Participante externo', label:'Participante externo'},
                                    ]}
                                    required
                                    variant="outlined" 
                                />
                            </Grid>
                            {/* Documento probatorio, dependiendo lo seleccionado en tipoRegistro */}
                            <Grid item xs={12} sx={{ display:(addCredential ? 'flex' : 'none')  }}>
                                <TextField
                                    type={"file"}
                                    fullWidth
                                    onChange={e => setFileState(e)}
                                    helperText="Subir documento probatorio (credencial en archivo PDF) *"
                                    variant='standard'
                                />
                            </Grid>

                            { /* Edad //* Nuevo */ }
                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    id="partEdad"
                                    label="Edad"
                                    name="partEdad"
                                    required
                                    size="small"
                                    type='number'
                                    // value={partEdad}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            { /* Sexo //* Nuevo */ }
                            <Grid item xs={6} >
                                <SelectCustom
                                    parentCallback={handleInputChange}
                                    name={"partSexo"}
                                    label={"Sexo"}
                                    options={[
                                        { value:'Hombre', label:'Hombre' },
                                        { value:'Mujer', label:'Mujer' },
                                    ]}
                                    required
                                />
                            </Grid>
                            { /* Telefono //* Nuevo */ }
                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    id="partTelefono"
                                    label="Teléfono"
                                    name="partTelefono"
                                    required
                                    size="small"
                                    type='number'
                                    // value={partTelefono}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            { /* Celular //* Nuevo */ }
                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    id="partCelular"
                                    label="Celular"
                                    name="partCelular"
                                    required
                                    size="small"
                                    type='number'
                                    // value={partCelular}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            { /* LenguaInd //* Nuevo */ }
                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    id="partLenguaIndigena"
                                    label="Lengua indígena"
                                    name="partLenguaIndigena"
                                    required
                                    size="small"
                                    // value={partLenguaIndigena}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            { /* Discapacidad //* Nuevo */ }
                            <Grid item xs={6} >
                                <SelectCustom
                                    parentCallback={handleInputChange}
                                    name={"partDiscapacidad"}
                                    label={"Discapacidad"}
                                    options={[
                                        { value:'Física/motriz', label:'Física/motriz' },
                                        { value:'Intelectual', label:'Intelectual' },
                                        { value:'Múltiple', label:'Múltiple' },
                                        { value:'Hipoacusia', label:'Hipoacusia' },
                                        { value:'Sordera', label:'Sordera' },
                                        { value:'Visual', label:'Visual' },
                                        { value:'Baja visión', label:'Baja visión' },
                                        { value:'Ceguera', label:'Ceguera' },
                                        { value:'Psicosocial', label:'Psicosocial' },
                                        { value:'Ninguna', label:'Ninguna' },
                                    ]}
                                    required
                                />
                            </Grid>
                            { /* Ocupacion //* Nuevo */ }
                            <Grid item xs={12} >
                                <SelectCustomWithOther parentCallback={handleInputChange}
                                    name={"partOcupacion"}
                                    label={"Ocupación"}
                                    options={[
                                        { value:'Estudiante', label:'Estudiante' },
                                        { value:'Técnico', label:'Técnico' },
                                        { value:'Investigador', label:'Investigador' },
                                    ]}
                                    variant='outlined'
                                />
                            </Grid>
                            {/* Nivel de estudios  //* Nuevo */}
                            <Grid item xs={6} >
                                <SelectCustom
                                    parentCallback={handleInputChange}
                                    name={"partGradoAcademico"}
                                    label={ "Nivel de estudios" }
                                    options={[
                                        { value:'Bachillerato', label:'Bachillerato' },
                                        { value:'Carrera técnica', label:'Carrera técnica' },
                                        { value:'Licenciatura', label:'Licenciatura' },
                                        { value:'Maestría', label:'Maestría' },
                                        { value:'Doctorado', label:'Doctorado' },
                                        { value:'Postdoctorado', label:'Postdoctorado' },
                                        { value:'Maestría profesionalizante', label:'Maestría profesionalizante' },
                                        { value:'Especialización', label:'Especialización' },
                                        { value:'Diplomado', label:'Diplomado' },
                                        { value:'Curso de superación', label:'Curso de superación' },
                                    ]}
                                    required
                                />
                            </Grid>
                            {/* Institucion de procedencia  //* Nuevo */}
                            <Grid item xs={12} paddingBottom={ 3 } >
                                <SelectCustomWithOther parentCallback={handleInputChange}
                                    name={"partInstProcedencia"}
                                    label={"Institución de procedencia *"}
                                    options={ 
                                        institucionesANUIES.map( inst => (
                                            { value: `${inst.nombre} (${inst.clave})`, label:`${inst.nombre} (${inst.clave})` }
                                            ))
                                    }
                                    inputWidth={12}
                                    paddingH={0}
                                    paddingV={0}
                                    variant='outlined' 
                                />
                            </Grid>

                        </Grid>
                    </Paper>

                    {/* Curso a inscribirse */}
                    <Paper elevation={2} >
                        <Grid container spacing={2} sx={{ pb: 2, pl: 2, pr: 2, mt: 2 }} >

                            <Grid item xs={12}>
                                <FormControl fullWidth required size="small">
                                    <InputLabel id="select-cursos">Registrarme a</InputLabel>
                                    <Select
                                        defaultValue={""}
                                        id="educonId"
                                        name="educonId"
                                        label={"Registrarme a"}
                                        onChange={handleCursoChange}
                                    >
                                        {educons.map(({ folio, curso, fechaInicio }) => (
                                            <MenuItem value={ folio } key={ folio } >{ 
                                                // curso 
                                                fechaInicio.slice(0, 10) + " · " + curso  
                                            }
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            {/* Modalidad, en caso de ser mixto */}
                            <Grid item xs={6} sx={{ display:(isMixed ? 'flex' : 'none') }} >
                            <SelectCustom
                                parentCallback={ handleModalidadChange }
                                name={"educonModalidad"}
                                label={"Seleccione la modalidad"}
                                options={[
                                    {value:'Presencial', label:'Presencial'},
                                    {value:'Virtual', label:'Virtual'},
                                ]}
                                required
                            />
                            </Grid>

                        </Grid>
                    </Paper>

                    {/* Boton */}
                    <Grid container spacing={2} sx={{ pt: 3 }}>
                    <Grid item xs={12}>
                        <Paper elevation={2} >
                            <Button
                                type="submit"
                                fullWidth
                                endIcon={<SendIcon />}
                                disabled={ isSendButtonDisabled() }
                            >
                                Enviar
                            </Button>
                        </Paper>
                    </Grid>
                    </Grid>
                </Box>



                {/* Footer */}
                <Grid container spacing={2} sx={{ pt: 8, pb: 2 }}>
                    <Grid item xs={12}>
                        <Divider />
                        <Typography gutterBottom sx={{ fontSize:'9px', textDecorationLine: 'none' }} paragraph align="right" color="text.secondary">
                            <strong>Centro de investigaciones Biológicas del Noroeste S.C.</strong><br />
                            Instituto Politécnico Nacional 195, Playa Palo de Santa Rita Sur.<br />
                            La Paz, B.C.S., México; C.P. 23096, Tel:(52) (612) 123-8484<br />
                            <a href="http://www.cibnor.gob.mx/component/content/article/472" target="_blank" rel="noreferrer" >Política de privacidad</a>
                        </Typography >
                    </Grid>
                </Grid>
            </Box>
            </Container>
            {/* Dialogo de espera */}
            <Dialog open={ isLoading || isWaiting }
                onClose={handleCloseWaitingDialog}
                disableEscapeKeyDown={true}
            >
                <DialogTitle id="alert-dialog-title" >
                    {"Un momento por favor..."}
                </DialogTitle>
                <DialogContent sx={{
                                margin: 2,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                            }}>
                    <CircularProgress thickness={ 1 } />
                </DialogContent>
            </Dialog>
            
            {/* Dialogo de espera porque se esta enviando la informacion */}
            <Dialog open={sendingForm}
                onClose={handleCloseWaitingDialog}
                disableEscapeKeyDown={true}
                >
                <DialogTitle id="alert-dialog-title" >
                    {"Enviando información..."}
                </DialogTitle>
                <DialogContent sx={{
                                margin: 2,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                            }}>
                    <CircularProgress thickness={ 1 } />
                </DialogContent>
            </Dialog>

        </ThemeProvider>
    );
};
